var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.122,
    height: 107.141,
    viewBox: "0 0 107.122 107.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ms-word",
    transform: "translate(-74 -1069.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ppt-icon",
    transform: "translate(0 703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20331",
    "data-name": "Group 20331",
    transform: "translate(-315 170.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_198",
    "data-name": "Union 198",
    d: "M2384.695-14276.561a53.21,53.21,0,0,1-15.694-37.883,53.2,53.2,0,0,1,15.7-37.867,53.211,53.211,0,0,1,37.865-15.7,53.193,53.193,0,0,1,37.868,15.691,53.2,53.2,0,0,1,15.693,37.867,53.249,53.249,0,0,1-15.695,37.887,53.205,53.205,0,0,1-37.866,15.7A53.21,53.21,0,0,1,2384.695-14276.561Zm-10.712-37.883a48.635,48.635,0,0,0,48.578,48.578,48.628,48.628,0,0,0,48.579-48.578,48.623,48.623,0,0,0-48.579-48.578,48.629,48.629,0,0,0-48.578,48.594Z",
    transform: "translate(-1980 14563.999)",
    fill: "#6b6b6b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10189",
    "data-name": "Rectangle 10189",
    transform: "translate(118 1119)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 22,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 38,
    height: 21,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20553",
    "data-name": "Group 20553",
    transform: "translate(-1.76 -2.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20552",
    "data-name": "Group 20552",
    transform: "translate(106.8 1101.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32239",
    "data-name": "Path 32239",
    d: "M12803.019,21481.047v-6.666l-7.975-8.307H12766.8v47.406h36.219",
    transform: "translate(-12766.8 -21466.074)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32240",
    "data-name": "Path 32240",
    d: "M12791.7,21466.074v9.533h9.809",
    transform: "translate(-12765.513 -21466.074)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32241",
    "data-name": "Path 32241",
    d: "M12771.1,21472.875h10.3",
    transform: "translate(-12764.141 -21463.342)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32242",
    "data-name": "Path 32242",
    d: "M12771.1,21478.074h17.739",
    transform: "translate(-12764.14 -21462.783)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }))), /*#__PURE__*/React.createElement("text", {
    id: "DOC",
    transform: "translate(125 1136)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Oswald-SemiBold, Oswald",
    fontWeight: 600,
    letterSpacing: "0.094em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DOC")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsword);
export default __webpack_public_path__ + "static/media/msword.1fcd45250e46fd1aa6f00a7a8cdf1e4d.svg";
export { ForwardRef as ReactComponent };